import * as React from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MenuContent from './MenuContent';
import OptionsMenu from './OptionsMenu';
import MuscleHeadTextIcon from '../../../assets/MuscleHeadTextIcon';
import ImageAvatarView from "@component/ImageAvatarView"
import { Link } from 'react-router-dom';

import { AccountContext } from "@context/AccountProvider";

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
  },
});

export default function SideMenu() {
  const { account } = React.useContext(AccountContext);
  const getShortEmail = (email, maxLength = 15) => {
    if (!email) return "";
    if (email.length <= maxLength) return email;
    return `${email.slice(0, maxLength - 3)}...`;
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: 'none', md: 'block' },
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: 'background.paper',
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          mt: '',
          p: 0.5,
        }}
      >
      </Box>
      <Link to="/admin/dashboard">
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
          <MuscleHeadTextIcon sx={{
            alignSelf: "center",
            height: "70px",
            width: "100%",
          }} />
        </Box>
      </Link>
      <Divider />
      <MenuContent />
      <Stack
        direction="row"
        sx={{
          p: 2,
          gap: 1,
          alignItems: 'center',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        {/* <Avatar
          sizes="small"
          alt="profile_img"
          src="/static/images/avatar/7.jpg"
          sx={{ width: 36, height: 36 }}
        /> */}
        <ImageAvatarView fileUuid={account.file_image_uuid} avatarSx={{ width: 50, height: 50}}/>
        
        <Box sx={{ flex: 1, minWidth: 0, mr: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }}>
            { account ? account.first_name + " " + account.last_name : "" }
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: 'text.secondary',
              display: 'block',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
          >
            { account ? getShortEmail(account.email) : "" }
          </Typography>
        </Box>
        <OptionsMenu />
      </Stack>
    </Drawer>
  );
}
